<template>
  <div>
    <div v-if="hasProfileUpdated">
      <p>Profile Update Requested.</p>
      <vs-button
        icon-pack="feather"
        :icon="updatedProfileShown ? 'icon-x' : 'icon-eye'"
        :color="updatedProfileShown ? 'danger' : 'primary'"
        type="filled"
        @click="viewUpdatedProfile()">
        {{ updatedProfileShown ? "Close" : "Show" }}
      </vs-button
      >
    </div>

        <div class="w-full flex items-center justify-center">
          <a
            id="profileImage"
            v-if="userDetail.profileImage"
            :href="userDetail.profileImage"
            target="_blank"
          >
            <div class="img-wrapper">
              <img :src="userDetail.profileImage" class="w-32 h-32 object-contain rounded-full mb-6" alt />
            </div>
          </a>
          <vs-avatar
            class="cursor-pointer w-32 h-32 object-contain rounded-full mb-6"
            @click="open_in_new_tab(defaultPP)"
            :src="defaultPP"
            v-else
          />
        </div>

    <div class="grid grid-cols lg:grid-cols-2 gap-4">
    
    <div
      class="w-full"
      v-if="
        (this.userDetail.userType === 'nurse' ||
        this.userDetail.userType === 'doctor') && 
        this.$isAuRegion()
      "
    >
      <div class="w-full">
        <label for="profileImage">AHPRA Certificate</label>
        <p v-if="!userDetail.ahpraCertificate" id="ahpraCertificate">N/A</p>
        <a
          id="ahpraCertificate"
          v-else-if="determineFileType(userDetail.ahpraCertificate) !== 'pdf'"
          :href="userDetail.ahpraCertificate"
          target="_blank"
        >
            <img :src="userDetail.ahpraCertificate" class="h-48 object-contain" alt />
        </a>
        <a
          id="ahpraCertificate"
          v-else
          :href="userDetail.ahpraCertificate"
          target="_blank"
        >
          <span>Click Here To View</span>
        </a>
      </div>
    </div>

    <div
      class="w-full"
      v-if="
        (this.userDetail.userType === 'nurse' ||
        this.userDetail.userType === 'doctor') && 
        this.$isAuRegion()
      "
    >
      <div class="w-full">
        <label for="insuranceCertificate">Insurance Certificate</label>
        <p v-if="!userDetail.insuranceCertificate" id="insuranceCertificate">
          N/A
        </p>
        <a
          id="insuranceCertificate"
          v-else-if="
            determineFileType(userDetail.insuranceCertificate) !== 'pdf'
          "
          :href="userDetail.ahpraCertificate"
          target="_blank"
        >
            <img
              :src="userDetail.insuranceCertificate"
              class="h-48 object-contain"
              alt
            />
        </a>
        <a
          id="insuranceCertificate"
          v-else
          :href="userDetail.insuranceCertificate"
          target="_blank"
        >
          <span>Click here to view</span>
        </a>
      </div>
    </div>

    <div class="w-full">
      <label for="firstName">First Name</label>
      <p id="firstName">{{ userDetail.firstName }}</p>
    </div>

    <div class="w-full">
      <label for="lastName">Last Name</label>
      <p id="lastName">{{ userDetail.lastName }}</p>
    </div>

    <div class="w-full">
      <label for="email">Email</label>
      <p class="break-all" id="email">{{ userDetail.email }}</p>
    </div>
   <vs-col
      vs-type="flex"
      vs-justify="left"
      vs-align="left"
      vs-w="6"
      v-if="
        this.userDetail.userType === 'basic' 
      "
    >
      <div class="w-full">
        <label for="contactNumber">Contact Number</label>
        <p v-if="!userDetail.contactNumber">N/A</p>
        <p v-else id="contactNumber">{{ userDetail.contactNumber }}</p>
      </div>
    </vs-col>
    
    <div
      class="w-full"
      v-if="
        ( this.userDetail.userType === 'nurse' ||
        this.userDetail.userType === 'doctor') && 
        this.$isAuRegion()
      "
    >
      <div class="w-full">
        <label for="ahpraRegistrationNumber">Ahpra Registration Number</label>
        <p v-if="!userDetail.ahpraRegistrationNumber">N/A</p>
        <p v-else id="ahpraRegistrationNumber">
          {{ userDetail.ahpraRegistrationNumber }}
        </p>
      </div>
    </div>

    <div
      class="w-full"
      v-if="
        (this.userDetail.userType === 'nurse' ||
        this.userDetail.userType === 'doctor') && 
        this.$isAuRegion()
      "
    >
      <div class="w-full">
        <label for="ahpraExiryDate">Ahpra Exiry Date</label>
        <p v-if="!userDetail.ahpraExiryDate">N/A</p>
        <p v-else id="ahpraExiryDate">
          {{ userDetail.ahpraExiryDate | date_formatter }}
        </p>
      </div>
    </div>

    <div
      class="w-full"
      v-if="
        (this.userDetail.userType === 'nurse' ||
        this.userDetail.userType === 'doctor') && 
        this.$isAuRegion()
      "
    >
      <div class="w-full">
        <label for="indemnityInsuranceProvider"
          >Indemnity Insurance Provider</label
        >
        <p v-if="!userDetail.indemnityInsuranceProvider">N/A</p>
        <p v-else id="indemnityInsuranceProvider">
          {{ userDetail.indemnityInsuranceProvider }}
        </p>
      </div>
    </div>

    <div
      class="w-full"
      v-if="
        (this.userDetail.userType === 'nurse' ||
        this.userDetail.userType === 'doctor') && 
        this.$isAuRegion()
      "
    >
      <div class="w-full">
        <label for="indemnityInsuranceNumber"
          >Indemnity Insurance Number</label
        >
        <p v-if="!userDetail.indemnityInsuranceNumber">N/A</p>
        <p v-else id="indemnityInsuranceNumber">
          {{ userDetail.indemnityInsuranceNumber }}
        </p>
      </div>
    </div>

    <div
      class="w-full"
      v-if="
        (this.userDetail.userType === 'nurse' ||
        this.userDetail.userType === 'doctor') && 
        this.$isAuRegion()
      "
    >
      <div class="w-full">
        <label for="indemnityInsuranceExpiry"
          >Indemnity Insurance Expiry</label
        >
        <p v-if="!userDetail.indemnityInsuranceExpiry">N/A</p>
        <p v-else id="indemnityInsuranceExpiry">
          {{ userDetail.indemnityInsuranceExpiry | date_formatter }}
        </p>
      </div>
    </div>

    <div
      class="w-full"
      v-if="userDetail.userType === 'nurse'"
    >
    </div>
  </div>
  </div>
</template>

<script>
import { capitalizeFirstLetter } from '../../../globalHelpers/string';

export default {
  name: 'ProfileDetail',
  components: {
  },
  data: () => ({
    defaultPP: require('@/assets/images/profile/default.png'),
    userDetail: {},
    actualUserDetail: {},
    hasProfileUpdated: false,
    updatedProfileShown: false,
    confidentAreasForToxin: '',
    confidentAreasForFiller: '',
    userRole: '',
  }),
  methods: {
    determineFileType(str) {
      var res = str.substring(str.length - 3, str.length);
      return res;
    },
    viewUpdatedProfile() {
      if (this.updatedProfileShown === false) {
        let emailOfUser = this.userDetail.email;
        this.userDetail = this.userDetail.tempProfile[0];
        this.userDetail.userType = this.actualUserDetail.userType;
        this.userDetail.status = 'Pending_Approval';
        this.userDetail.email = emailOfUser;
        this.updatedProfileShown = true;
      } else {
        this.userDetail = this.actualUserDetail;
        this.updatedProfileShown = false;
      }
    },
  },
  async created() {
    this.$vs.loading();
    this.$store
      .dispatch(
        'general/getUserDetailForProfile',
        this.$store.state.AppActiveUser._id
      )
      .then((response) => {
        this.userDetail = response.data.data;
        this.actualUserDetail = response.data.data;
        if (
          (this.userDetail.userType === 'nurse' ||
            this.userDetail.userType === 'doctor') &&
          this.userDetail.tempProfile &&
          this.userDetail.tempProfile.length > 0
        )
          this.hasProfileUpdated = true;

        if (this.userDetail.userType === 'nurse') {
          if (this.userDetail.confidentAreasForToxinTreatment) {
            let obj = this.userDetail.confidentAreasForToxinTreatment;

            let keys = Object.keys(obj);

            let filtered = keys.filter(function (key) {
              return obj[key];
            });

            if (filtered && filtered.length > 0)
              this.confidentAreasForToxin = filtered.join(', ');
            else this.confidentAreasForToxin = 'N/A';
          } else {
            this.confidentAreasForToxin = 'N/A';
          }
        }

        if (this.userDetail.userType === 'nurse') {
          if (this.userDetail.confidentAreasForFillerTreatment) {
            let obj = this.userDetail.confidentAreasForFillerTreatment;

            let keys = Object.keys(obj);

            let filtered = keys.filter(function (key) {
              return obj[key];
            });

            if (filtered && filtered.length > 0)
              this.confidentAreasForFiller = filtered.join(', ');
            else this.confidentAreasForFiller = 'N/A';
          } else {
            this.confidentAreasForFiller = 'N/A';
          }
        }

        this.userRole = capitalizeFirstLetter(this.userDetail.userType);
        this.$vs.loading.close();
      })
      .catch(() => {
        this.$vs.loading.close();
      });
  },
};
</script>

<style>
p {
  font-size: 15px;
  font-weight: 500;
}

label {
  font-size: 0.8rem;
}

div.vs-con-textarea {
  margin-top: 0 !important;
}

.uploadedImages {
  text-align: left !important;
}

.dateClass {
  margin-top: 0 !important;
}
</style>
